import { Coffee, Users, MessageCircle, Zap } from 'lucide-react';

interface OfficeControlsProps {
  agentCount: number;
  activeConversations: number;
  onWaterCooler: () => void;
  onTeamMeeting: () => void;
}

export default function OfficeControls({
  agentCount,
  activeConversations,
  onWaterCooler,
  onTeamMeeting,
}: OfficeControlsProps) {
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      {/* Left: Legend */}
      <div className="flex items-center gap-4 text-xs text-text-secondary">
        <span className="font-medium text-text-primary text-sm">Virtual Office</span>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-success animate-pulse-dot" />
          <span>Working</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-text-muted" />
          <span>Idle</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-error" />
          <span>Error</span>
        </div>
      </div>

      {/* Center: Stats */}
      <div className="flex items-center gap-4 text-xs text-text-secondary">
        <div className="flex items-center gap-1.5">
          <Users className="w-3.5 h-3.5 text-text-muted" />
          <span>{agentCount} agents online</span>
        </div>
        <div className="flex items-center gap-1.5">
          <MessageCircle className="w-3.5 h-3.5 text-text-muted" />
          <span>{activeConversations} active {activeConversations === 1 ? 'chat' : 'chats'}</span>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={onWaterCooler}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-text-secondary bg-bg-tertiary border border-border-subtle rounded-lg hover:bg-bg-secondary hover:text-text-primary transition-colors"
        >
          <Coffee className="w-3.5 h-3.5" />
          Water Cooler
        </button>
        <button
          onClick={onTeamMeeting}
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-text-secondary bg-bg-tertiary border border-border-subtle rounded-lg hover:bg-bg-secondary hover:text-text-primary transition-colors"
        >
          <Zap className="w-3.5 h-3.5" />
          Team Pulse
        </button>
      </div>
    </div>
  );
}
